/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v1
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AssignedControls } from '../model';
// @ts-ignore
import type { Assignment } from '../model';
// @ts-ignore
import type { ControlStatusFilter } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { ProjectsDashboard } from '../model';
/**
 * DashboardApi - axios parameter creator
 */
export const DashboardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Controls
         * @param {string | null} [controlSearch] Search for a control.
         * @param {string | null} [projectIdOfControls] Filter controls by project id.
         * @param {ControlStatusFilter} [controlStatus] Filter controls by status.
         * @param {Assignment} [assignedAs] Either the assignee or the assignee to review controls.
         * @param {string | null} [sortBy] Sort controls by a field.
         * @param {boolean} [descending] Sort either descending (True) or ascending (False).
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlsDashboardAssignedControlsGet: async (controlSearch?: string | null, projectIdOfControls?: string | null, controlStatus?: ControlStatusFilter, assignedAs?: Assignment, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboard/assigned_controls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (controlSearch !== undefined) {
                localVarQueryParameter['control_search'] = controlSearch;
            }

            if (projectIdOfControls !== undefined) {
                localVarQueryParameter['project_id_of_controls'] = projectIdOfControls;
            }

            if (controlStatus !== undefined) {
                localVarQueryParameter['control_status'] = controlStatus;
            }

            if (assignedAs !== undefined) {
                localVarQueryParameter['assigned_as'] = assignedAs;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }

            if (descending !== undefined) {
                localVarQueryParameter['descending'] = descending;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Projects
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsDashboardProjectsGet: async (page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dashboard/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardApi - functional programming interface
 */
export const DashboardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Controls
         * @param {string | null} [controlSearch] Search for a control.
         * @param {string | null} [projectIdOfControls] Filter controls by project id.
         * @param {ControlStatusFilter} [controlStatus] Filter controls by status.
         * @param {Assignment} [assignedAs] Either the assignee or the assignee to review controls.
         * @param {string | null} [sortBy] Sort controls by a field.
         * @param {boolean} [descending] Sort either descending (True) or ascending (False).
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getControlsDashboardAssignedControlsGet(controlSearch?: string | null, projectIdOfControls?: string | null, controlStatus?: ControlStatusFilter, assignedAs?: Assignment, sortBy?: string | null, descending?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignedControls>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getControlsDashboardAssignedControlsGet(controlSearch, projectIdOfControls, controlStatus, assignedAs, sortBy, descending, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.getControlsDashboardAssignedControlsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Projects
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProjectsDashboardProjectsGet(page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectsDashboard>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectsDashboardProjectsGet(page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardApi.getProjectsDashboardProjectsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardApi - factory interface
 */
export const DashboardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Controls
         * @param {DashboardApiGetControlsDashboardAssignedControlsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getControlsDashboardAssignedControlsGet(requestParameters: DashboardApiGetControlsDashboardAssignedControlsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AssignedControls> {
            return localVarFp.getControlsDashboardAssignedControlsGet(requestParameters.controlSearch, requestParameters.projectIdOfControls, requestParameters.controlStatus, requestParameters.assignedAs, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Projects
         * @param {DashboardApiGetProjectsDashboardProjectsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProjectsDashboardProjectsGet(requestParameters: DashboardApiGetProjectsDashboardProjectsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ProjectsDashboard> {
            return localVarFp.getProjectsDashboardProjectsGet(requestParameters.page, requestParameters.size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getControlsDashboardAssignedControlsGet operation in DashboardApi.
 */
export interface DashboardApiGetControlsDashboardAssignedControlsGetRequest {
    /**
     * Search for a control.
     */
    readonly controlSearch?: string | null

    /**
     * Filter controls by project id.
     */
    readonly projectIdOfControls?: string | null

    /**
     * Filter controls by status.
     */
    readonly controlStatus?: ControlStatusFilter

    /**
     * Either the assignee or the assignee to review controls.
     */
    readonly assignedAs?: Assignment

    /**
     * Sort controls by a field.
     */
    readonly sortBy?: string | null

    /**
     * Sort either descending (True) or ascending (False).
     */
    readonly descending?: boolean

    readonly page?: number

    readonly size?: number
}

/**
 * Request parameters for getProjectsDashboardProjectsGet operation in DashboardApi.
 */
export interface DashboardApiGetProjectsDashboardProjectsGetRequest {
    readonly page?: number

    readonly size?: number
}

/**
 * DashboardApi - object-oriented interface
 */
export class DashboardApi extends BaseAPI {
    /**
     * 
     * @summary Get Controls
     * @param {DashboardApiGetControlsDashboardAssignedControlsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getControlsDashboardAssignedControlsGet(requestParameters: DashboardApiGetControlsDashboardAssignedControlsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getControlsDashboardAssignedControlsGet(requestParameters.controlSearch, requestParameters.projectIdOfControls, requestParameters.controlStatus, requestParameters.assignedAs, requestParameters.sortBy, requestParameters.descending, requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Projects
     * @param {DashboardApiGetProjectsDashboardProjectsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProjectsDashboardProjectsGet(requestParameters: DashboardApiGetProjectsDashboardProjectsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return DashboardApiFp(this.configuration).getProjectsDashboardProjectsGet(requestParameters.page, requestParameters.size, options).then((request) => request(this.axios, this.basePath));
    }
}

